<template>
    <okraina-sheet v-model:visible="visible">
        <template v-slot:body>
            <div class="okraina-speech">
                <div class="icon-wrap">
                    <div class="icon fi fi-mic"></div>
                </div>

                <template v-if="!error">
                    <div class="promt" v-if="!text">Скажите что-нибудь</div>
                    <div class="text" v-html="text"></div>
                </template>
                <template v-else>
                    <div class="error">Извините, не удалось распознать текст...</div>

                    <div class="btn btn-block btn2 slim" @click="start">Попробовать снова</div>
                </template>

            </div>
        </template>
    </okraina-sheet>
</template>

<script>

import okrainaSheet from '@/components/sheet.vue'

import bus from "@/plugins/bus";

export default {
    name: "okraina-speech",
    components: {
        okrainaSheet,
    },
    data() {
        return {
            visible: false,
            watchVisible: false,
            params: false,
            text: "",
            timer: 0,
            error: false
        }
    },
    methods: {

        open(params) {
            this.params = params;
            this.visible = true;
            this.text = "";
            this.watchVisible = true;
            this.start();
        },

        start() {
            this.error = false;
            let vm = this;
            setTimeout(() => {

                bus.emit("OKRAINA_SPEECH_RECOGNITION_E_START", {
                    onStart: () => {
                        vm.waitFinish();
                    },
                    resolve: (text) => {
                        vm.text = text;
                        vm.waitFinish();
                    },
                });

            }, 200);
        },

        waitFinish() {
            if (this.timer > 0) {
                clearTimeout(this.timer);
            }

            let vm = this;
            this.timer = setTimeout(() => {
                vm.finish();
            }, this.text ? 2000 : 5000);
        },

        finish() {

            if (this.visible) {
                if (this.text) {
                    this.params.resolve(this.text);
                    this.close();

                } else {
                    this.error = true;
                }
            } else {
                this.close();
            }
        },

        close() {
            this.visible = false;
            bus.emit("OKRAINA_SPEECH_RECOGNITION_E_STOP");
        }
    },
    mounted() {
        bus.on("OKRAINA_SPEECH_RECOGNITION_E_GET", this.open);
    },
    unmounted() {
        bus.off("OKRAINA_SPEECH_RECOGNITION_E_GET", this.open);
    },

}
</script>

<style lang="scss">
.okraina-speech {
    padding: 0px 0px 0px;
    text-align: center;

    color: var(--color-sheet-text);

    .icon-wrap {
        position: relative;
        height: 80px;
        width: 80px;
        margin: 0px auto 20px;
        background-color: var(--color-sheet-block-background);
        color: var(--color-sheet-block-text);
        border-radius: 50%;
        box-shadow: rgba(1, 0, 61, 0.15) 0px 0px 15px;

        .icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 30px;
        }
    }

    .promt {
        font-size: 16px;
    }

    .error {
        margin-bottom: 10px;
    }


}
</style>